import React from 'react';
import {SafeAreaView, ScrollView, View} from 'react-native';
import Text from '../../components/elements/Text';
import BreadCrumbs from '../../components/elements/BreadCrumbs';
import {BUTTON_TYPES, DIABETES_TYPES} from '../../utils/Constants';
import makeStyles from './styles.web';
import {useTheme, useThemedStyles} from '../../theme';
import {tID} from '../../utils/TestIdHelper';
import CommonStyles from '../../utils/CommonStyles';
import Divider from '../../components/elements/Divider';
import Button from '../../components/elements/Button';
import {
  ClosedEyeIcon,
  OpenEyeIcon,
  LogoGroup,
  LeftArrowIcon,
} from '../../utils/SvgIcons';

const UI = ({
  selectedType,
  otherInput,
  onPressSave,
  onPressSkip,
  renderList,
  isSourceApp,
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  // Check if "Other" is selected but text input is empty
  const isOtherSelectedWithoutInput = selectedType.includes(DIABETES_TYPES.Other) && !otherInput.trim();
  return (
    <SafeAreaView
      testID={tID('DiabetesType-SafeAreaView-Main')}
      style={styles.maincontainer}>
      <ScrollView
        testID={tID('DiabetesType-ScrollView-1')}
        style={styles.formView}>
        <LogoGroup width={146} height={40} style={CommonStyles.mv_40} />
        <View
          testID={tID('DiabetesType-View-SigninRouteContainer')}
          style={styles.signinRouteContainer}>
          <LeftArrowIcon width={5} height={9} tintColor={colors.textDisabled} />
          <Text
            testID={tID('DiabetesType-Text-SigninRoute')}
            variation="Text1SemiBold"
            color={colors.textDisabled}
            lineHeight={21}
            style={CommonStyles.mh_12}>
            Sign-In
          </Text>
          <LeftArrowIcon width={5} height={9} tintColor={colors.textDisabled} />
          <Text
            testID={tID('DiabetesType-Text-PersonalDetails')}
            variation="Text1SemiBold"
            color={colors.textDisabled}
            lineHeight={21}
            style={CommonStyles.mh_12}>
            Personal Details
          </Text>
          <LeftArrowIcon
            width={5}
            height={9}
            tintColor={colors.link}
          />
          <Text
            testID={tID('DiabetesType-Text-PhoneVerification')}
            variation="Text1SemiBold"
            color={colors.link}
            lineHeight={21}
            style={CommonStyles.ml_12}>
            Phone Verification
          </Text>
        </View>
        <Text
          testID={tID('DiabetesType-Text-Title')}
          variation="HeadlineBold28"
          color={colors.textPrimary}
          style={CommonStyles.mb_12}>
          Diabetes Type
        </Text>
        <Text
          testID={tID('DiabetesType-Text-SubTitle')}
          variation="Body1Regular"
          color={colors.textSecondary}
          style={CommonStyles.mb_8}>
          Add your personal information to create your account.
        </Text>
        <View
          testID={tID('DiabetesType-View-BreadCrumbsContainer')}
          style={styles.dotContainer}>
          <BreadCrumbs
            current={1}
            total={1}
            activeColor={colors.link}
            currentPassiveColor={colors.link}
            passiveColor={colors.borderMuted}
            activeDotWidth={12}
            activeDotHeight={12}
            currentPassiveDotWidth={12}
            currentPassiveDotHeight={12}
            passiveDotWidth={12}
            passiveDotHeight={12}
            containerStyle={styles.marginLeftMinus4}
          />
          <BreadCrumbs
            current={1}
            total={1}
            activeColor={colors.link}
            currentPassiveColor={colors.link}
            passiveColor={colors.borderMuted}
            activeDotWidth={12}
            activeDotHeight={12}
            currentPassiveDotWidth={12}
            currentPassiveDotHeight={12}
            passiveDotWidth={12}
            passiveDotHeight={12}
            containerStyle={styles.marginLeftMinus10}
          />
          {!isSourceApp && (
            <BreadCrumbs
              current={1}
              total={1}
              activeColor={colors.link}
              currentPassiveColor={colors.link}
              passiveColor={colors.borderMuted}
              activeDotWidth={12}
              activeDotHeight={12}
              currentPassiveDotWidth={12}
              currentPassiveDotHeight={12}
              passiveDotWidth={12}
              passiveDotHeight={12}
              containerStyle={styles.marginLeftMinus10}
            />
          )}
          <BreadCrumbs
            current={1}
            total={1}
            activeColor={colors.link}
            currentPassiveColor={colors.link}
            passiveColor={colors.borderMuted}
            activeDotWidth={24}
            activeDotHeight={12}
            currentPassiveDotWidth={12}
            currentPassiveDotHeight={12}
            passiveDotWidth={12}
            passiveDotHeight={12}
            containerStyle={styles.activeDot}
          />
        </View>
        <Divider />
        <View style={styles.checkboxList}>{renderList()}</View>
      </ScrollView>
      <View style={styles.buttonContainer}>
        <Button
          testID={tID('DiabetesType-Button-SkipStep')}
          title={'Skip Step'}
          titleColor={colors.link}
          style={styles.skipButton}
          onPress={onPressSkip}
        />
        <Button
          testID={tID('DiabetesType-Button-Save')}
          disabled={selectedType.length == 0 || isOtherSelectedWithoutInput}
          title={'Save'}
          buttonType={BUTTON_TYPES.Filled}
          titleColor={colors.textOnAccent}
          style={styles.saveButton}
          onPress={onPressSave}
        />
      </View>
    </SafeAreaView>
  );
};

export default UI;
